import request from '@/utils/request'


//用户名下电站（统计类数据）

export function getStationStatistics() {
  return request({
    url: '/dashboard/v3/workbench/stationStatistics',
    method: 'get',
  })
}
/**
 * 获取告警列表
 * @param {Object} data - 请求参数
 */
export function getMonthIncomeAndPower(data) {
  return request({
    url: '/dashboard/v3/workbench/monthIncomeAndPower',
    method: 'get',
    params: data
  })
}

/**
 * 获取告警列表
 * @param {Object} data - 请求参数
 */
export function getAlarmStatistics(data) {
  return request({
    url: '/dashboard/v3/workbench/alarmStatistics',
    method: 'get',
    params: data
  })
}


/** 获取电站列表 */
export function getStationList(data) {
  return request({
    url: '/dashboard/v3/workbench/myStationList',
    method: 'get',
    params: data
  })
}

/** 获取待办事项 */
export function getTodoList(data) {
  return request({
    url: '/dashboard/v3/workbench/todoList',
    method: 'get',
    params: data
  })
}

/**
* 获取电站统计数据
* @returns {Promise} 返回电站数量、容量等统计信息
*/
export function getStationData() {
  return request({
    url: '/device/v2/station/data',
    method: 'get'
  })
}

/* 切换待办状态（1:未读 2:已读） */
export function switchTodoReadStatus(id, data = {}) {
  return request({
    url: `/dashboard/v3/workbench/changeState/${id}`,
    method: 'post',
    data
  })
}

/** 新增待办事项 */
export function insertTodo(data) {
  return request({
    url: '/dashboard/v3/workbench/insertTodo',
    method: 'post',
    data,
  })
}
